import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetUserSettingsQuery, useSaveUserSettingMutation } from '../../../modules/user/api/user-api';
import { UserSettings } from '../../../modules/user/models/user-settings';
import styles from './language-select.module.css';

const languages = [
  { key: 'en', name: 'EN' },
  { key: 'el', name: 'EL' },
  { key: 'lt', name: 'LT' },
  { key: 'pl', name: 'PL' },
];

const LanguageSelect = (): JSX.Element => {
  const { i18n } = useTranslation();
  const [saveSetting] = useSaveUserSettingMutation();
  const { data: userSettings } = useGetUserSettingsQuery();

  const changeLanguage = (value: string) => {
    saveSetting({
      name: UserSettings.SelectedLanguage,
      value,
    });
    i18n.changeLanguage(value);
  };

  const defaultLanguage = useMemo(
    () => userSettings?.[UserSettings.SelectedLanguage] || i18n.resolvedLanguage,
    [i18n.resolvedLanguage, userSettings],
  );

  return (
    <Select
      labelRender={() => languages.find(language => language.key === defaultLanguage)?.name}
      value={defaultLanguage}
      onChange={changeLanguage}
      className={styles.languageSelect}
    >
      {languages
        .filter(language => language.key !== defaultLanguage)
        .map(language => (
          <Select.Option key={language.key} value={language.key} style={{ textAlign: 'center' }}>
            {language.name}
          </Select.Option>
        ))}
    </Select>
  );
};

export default LanguageSelect;
